import { Bar } from 'vue-chartjs'

export default {
    extends: Bar,
    props: {
        chartdata: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        options: {
            tooltips: {
                enabled: false
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [
                    {
                        display: false,
                        ticks: {
                            display: false
                        },
                        gridLines: {}
                    }
                ],
                xAxes: [
                    {
                        display: false,
                        ticks: {
                            display: false
                        },
                        barPercentage: 1,
                        categoryPercentage: 0.9,
                        gridLines: {}
                    }
                ]
            },
            legend: {
                display: false
            }
        }
    }),
    mounted() {
        this.renderChart(this.chartdata, this.options)
    }
}
